export enum MatchResultEnum {
  WIN = 'WIN',
  LOOSE = 'LOOSE',
  NULL = 'NULL',
  FORFAIT = 'FORFAIT',
}
